import React from "react";
import { cn } from "../../utils";

export default function GlobeIcon({ className, width, height }) {
  return (
    <svg
      width={width || 32}
      height={height || 32}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cn("tbk-min-w-0 tbk-shrink-0", className)}
      role="presentation"
      aria-hidden="true"
    >
      <path
        d="M16 1C7.729 1 1 7.729 1 16C1 24.271 7.729 31 16 31C24.271 31 31 24.271 31 16C31 7.729 24.271 1 16 1ZM27.9972 11H22.6257C22.154 7.96125 21.2572 5.42 20.0683 3.66125C23.6515 4.84575 26.551 7.543 27.9972 11ZM21 16C21 17.0478 20.9467 18.047 20.8557 19H11.1442C11.0533 18.047 11 17.0478 11 16C11 14.9522 11.0533 13.953 11.1442 13H20.8555C20.9467 13.953 21 14.9522 21 16ZM16 29C14.1945 29 12.2353 25.8818 11.4078 21H20.5923C19.7648 25.8818 17.8055 29 16 29ZM11.4078 11C12.2353 6.11825 14.1945 3 16 3C17.8055 3 19.7648 6.11825 20.5923 11H11.4078ZM11.9318 3.66125C10.7428 5.42025 9.84575 7.96125 9.37425 11H4.00275C5.449 7.543 8.3485 4.84575 11.9318 3.66125ZM3.36325 13H9.1335C9.049 13.9653 9 14.9648 9 16C9 17.0352 9.049 18.0347 9.13375 19H3.36325C3.13425 18.035 3 17.034 3 16C3 14.966 3.13425 13.965 3.36325 13ZM4.00275 21H9.374C9.84575 24.0387 10.7425 26.58 11.9315 28.3388C8.34825 27.1543 5.449 24.457 4.00275 21ZM20.0683 28.3388C21.2572 26.5798 22.1542 24.0387 22.6257 21H27.997C26.551 24.457 23.6518 27.1543 20.0683 28.3388ZM28.6367 19H22.8662C22.951 18.0347 23 17.0352 23 16C23 14.9648 22.951 13.9653 22.8662 13H28.6365C28.8657 13.965 28.9998 14.966 28.9998 16C28.9998 17.034 28.8657 18.035 28.6367 19Z"
        fill="currentColor"
      />
    </svg>
  );
}
